import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { ChangeDataDto } from '../dtos/my-profile/my-profile.dto';
import { ChangePasswordDto } from '../dtos/my-profile/my-profile.dto';
import { BaseService } from './base.service';
import { Profiler } from '../services/constants/map-forest'
import { Notification } from '../services/constants/map-forest'
import { AuthKeycloakService } from './auth-keycloak.service';


@Injectable()
export class ProfileService extends BaseService {
  constructor(
    private http: HttpClient, 
    protected authKeycloakService: AuthKeycloakService
  ) {
    super(authKeycloakService);

  }

  seeuser(): Observable<any> {
    return this.http
      .get(`${Profiler.PROFILE}/`, this.authenticatedHeader())
      .pipe(map(this.extractData), catchError(this.serviceError));
  }

  update(dto: ChangeDataDto): Observable<any> {
    return this.http
      .patch(`${Profiler.PROFILE}${'/update'}/`, dto, this.authenticatedHeader())
      .pipe(map(this.extractData), catchError(this.serviceError));
  }

  changepwd(dto: ChangePasswordDto): Observable<any> {
    return this.http
      .patch(`${Profiler.PROFILE}${'/change-password'}/`, dto, this.authenticatedHeader())
      .pipe(map(this.extractData), catchError(this.serviceError));
  }

  sessions(): Observable<any> {
    return this.http
      .get(`${Profiler.PROFILE}${'/sessions'}/`, this.authenticatedHeader())
      .pipe(map(this.extractData), catchError(this.serviceError));
  }

  searchsessions(): Observable<any> {
    return this.http
      .post(`${Profiler.PROFILE}${'/search-sessions'}/`, this.authenticatedHeader())
      .pipe(map(this.extractData), catchError(this.serviceError));
  }

  importprofileimage(filel: File): Observable<any> {
  const formData = new FormData();
  formData.append("img_file", filel, filel.name);

  // pega o token de forma síncrona
  const user_token = this.authKeycloakService.getToken();

  const defined = {
    headers: new HttpHeaders({
      Authorization: `Bearer ${user_token?.toString()}`,
    }),
  };

  return this.http
    .post(`${Profiler.PROFILE}/choose-profile-picture/`, formData, defined)
    .pipe(map(this.extractData), catchError(this.serviceError));
}


  seeprofileimage(): Observable<any> {
    return this.http
      .get(`${Profiler.PROFILE}${'/load-profile-pic'}/`, this.authenticatedHeader())
      .pipe(map(this.extractData), catchError(this.serviceError));
  }

  getNotifications(): Observable<any> {
    return this.http
      .get(`${Notification.NOTIFICATION}/user/`, this.authenticatedHeader())
      .pipe(map(this.extractData), catchError(this.serviceError));
  }

  
  getPicture(): Observable<Blob> {
    // pega o token de forma síncrona
    const user_token = this.authKeycloakService.getToken();

    return this.http
      .get(`${Profiler.PROFILE}/picture/`, {
        responseType: 'blob',
        headers: new HttpHeaders({
          Authorization: `Bearer ${user_token?.toString()}`,
        }),
      })
      .pipe(catchError(this.serviceError));
  }


  uploadPicture(file: FormData): Observable<any> {
  // pega o token de forma síncrona
  const user_token = this.authKeycloakService.getToken();

  const defined = {
    headers: new HttpHeaders({
      Authorization: `Bearer ${user_token?.toString()}`,
    }),
  };

  return this.http
    .post(`${Profiler.PROFILE}/picture/`, file, defined)
    .pipe(map(this.extractData), catchError(this.serviceError));
}


  removePicture(): Observable<any>{
    return this.http
    .delete(`${Profiler.PROFILE}${'/picture'}/`, this.authenticatedHeader())
    .pipe(map(this.extractData), catchError(this.serviceError));
  }
}
